document.addEventListener("DOMContentLoaded", function () {
  const addToCartForms = document.querySelectorAll('form[action*="/cart/add"]');

  addToCartForms.forEach((form) => {
    form.addEventListener("submit", async (event) => {
      event.preventDefault();

      const addBtn = form.querySelector(".add-to-cart-btn");
      const formData = new FormData(form);

      const addRes = await fetch(form.getAttribute("action"), {
        method: "post",
        headers: { Accept: "application/json" },
        body: formData,
      });

      if (!addRes.ok) {
        if (addBtn) {
          const originalText = addBtn.textContent;
          addBtn.textContent = "Stok Yetersiz";
          setTimeout(() => {
            addBtn.textContent = originalText;
          }, 2500);
        }
        return;
      }

      const line = await addRes.json().catch(() => null);
      if (window.hbTrack && line) {
        // /cart/add tek urunde line item, coklu gonderimde {items:[...]} doner.
        // Bu endpoint fiyati kurus degil, "215.00" formatinda TL string'i verir.
        const item = Array.isArray(line.items) ? line.items[0] : line;
        const qty = Number(formData.get("quantity")) || 1;
        const unitPrice =
          parseFloat(item.price) || Number(item.presentment_price) || 0;
        const variantId = item.variant_id || item.id;
        // Basligi Liquid'den beslenen hbItemsById haritasindan al. /cart/add yaniti
        // basligi bazen cevrilmemis haliyle donuyor ve GA4'te ayni item_id iki farkli
        // item_name ile iki satira boluniyordu (or. "Yaprak Reyhan – 50gr" /
        // "Basil Leaf – 50gr", ayni id 41248436060366).
        const mapped =
          window.hbItemsById && window.hbItemsById[String(variantId)];
        window.hbTrack("add_to_cart", {
          currency: "TRY",
          value: unitPrice * qty,
          items: [
            {
              item_id: variantId,
              item_name:
                (mapped && mapped.item_name) || item.product_title || item.title,
              price: unitPrice,
              quantity: qty,
              item_list_id: (mapped && mapped.item_list_id) || undefined,
              item_list_name: (mapped && mapped.item_list_name) || undefined,
            },
          ],
        });
      }

      const res = await fetch("/cart.json");
      const cart = await res.json();

      document.querySelectorAll(".cart-count").forEach((el) => {
        el.textContent = cart.item_count;
        el.classList.add("items");
      });

      if (addBtn) {
        addBtn.textContent = "Sepete Eklendi";
        addBtn.classList.add("added-to-cart");
        addBtn.classList.add("disabled");
      }

      // Mobil sepet cubugu: ucan gorsel animasyonu + modal icerigini yenile (cart-drawer.js)
      document.dispatchEvent(
        new CustomEvent("hb:cart:added", { detail: { form, cart } }),
      );
    });
  });
});
